import { useCallback } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router';

interface IUseRedirections {
    redirect: (path: string, params: Record<string, unknown>, replace: boolean) => void;
}

export const useRedirections = (): IUseRedirections => {
    const navigate = useNavigate();
    const tenantParams = useParams();

    const redirect = useCallback(
        (path: string, params: Record<string, unknown>, replace: boolean) => {
            const newPath = generatePath(path, { ...tenantParams, ...params });

            navigate(newPath, { replace });
        },
        [navigate, tenantParams],
    );

    return {
        redirect,
    };
};
